var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"broadcast-section"},[(_vm.broadcast)?_c('WizardForm',{attrs:{"page-type":"update","broadcast":_vm.broadcast},on:{"broadcast-changed":_vm.broadcastChanged}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }